import './style/index.less';
import OtherLogins from './OtherLogins';

export default OtherLogins;
